import { message } from 'antd';
import React from 'react';
type NotificationType = 'success' | 'warning' | 'error';

export const openNotificationWithIcon = (type: NotificationType, content, duration = 5) => {
  message.destroy();
  const messageInstance = message[type](<div id="notification-content">{content}</div>, duration);
  message.config({
    maxCount: 1,
  });

  return messageInstance;
};

export const openNotificationWarnning = (type: NotificationType, content, duration = 5) => {
  message[type](<div id="notification-content--2">{content}</div>, duration);
};

export const openNotificationWithIconError = (type: NotificationType, content, sub, duration = 5) => {
  message.destroy();
  message['error'](
    <>
      <div id="notification-content--3">{content}</div>
      <div>{sub}</div>
    </>,
    duration,
  );
  message.config({
    maxCount: 1,
  });
};
